var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61809 17.9878C6.2218 17.5721 4.97892 16.8004 3.99478 15.7777C4.36192 15.3426 4.58317 14.7804 4.58317 14.1665C4.58317 12.7858 3.46388 11.6665 2.08317 11.6665C1.99965 11.6665 1.91708 11.6706 1.83567 11.6786C1.72475 11.1363 1.6665 10.5749 1.6665 9.99985C1.6665 9.12877 1.80016 8.28889 2.04808 7.4996C2.05976 7.49976 2.07145 7.49985 2.08317 7.49985C3.46388 7.49985 4.58317 6.38056 4.58317 4.99985C4.58317 4.60347 4.49092 4.22864 4.32675 3.89568C5.29046 2.99959 6.46671 2.32897 7.77155 1.96777C8.185 2.77821 9.02763 3.33319 9.99984 3.33319C10.972 3.33319 11.8147 2.77821 12.2281 1.96777C13.533 2.32897 14.7092 2.99959 15.6729 3.89568C15.5088 4.22864 15.4165 4.60347 15.4165 4.99985C15.4165 6.38056 16.5358 7.49985 17.9165 7.49985C17.9282 7.49985 17.9399 7.49976 17.9516 7.4996C18.1995 8.28889 18.3332 9.12877 18.3332 9.99985C18.3332 10.5749 18.2749 11.1363 18.164 11.6786C18.0826 11.6706 18 11.6665 17.9165 11.6665C16.5358 11.6665 15.4165 12.7858 15.4165 14.1665C15.4165 14.7804 15.6378 15.3426 16.0049 15.7777C15.0208 16.8004 13.7779 17.5721 12.3816 17.9878C12.0593 16.9798 11.1148 16.2498 9.99984 16.2498C8.88484 16.2498 7.94034 16.9798 7.61809 17.9878Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 12.9168C11.611 12.9168 12.9168 11.611 12.9168 10.0002C12.9168 8.38933 11.611 7.0835 10.0002 7.0835C8.38933 7.0835 7.0835 8.38933 7.0835 10.0002C7.0835 11.611 8.38933 12.9168 10.0002 12.9168Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingTwo);
export default __webpack_public_path__ + "static/media/setting-two.c70a129e41a41dd2cb1dd5dc2db27936.svg";
export { ForwardRef as ReactComponent };